import { GKCard, GKCardBody, GKCardImg } from "@granular/gds";
import { FormattedMessage } from "react-intl";
import styles from "./LoginCardLayout.module.css";

export const LoginCardLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <GKCard className={styles.cardWrapper}>
      {/* Header */}
      <div className={styles.cardHeader}>
        <GKCardImg
          className="img-fluid"
          src="https://static.granular.ag/common/gds-assets/latest/lib/images/logos/granular-insights-logo-lockup-h.svg"
        />
        <div className="text-muted text-center mt-2">
          <FormattedMessage id="sign-into-insights-account" />
        </div>
      </div>
      {/* Content */}
      <GKCardBody className={styles.clearDefaultStyles}>{children}</GKCardBody>
    </GKCard>
  );
};
